import { exportExcel } from "@api/stores/purchaseInvoiceItemReport/exportExcel/path";
import { exportPDF } from "@api/stores/purchaseInvoiceItemReport/exportPDF/path";
import { exportSinglePDF } from "@api/stores/purchaseInvoiceItemReport/exportSinglePDF/path";
import { stats } from "@api/stores/purchaseInvoiceItemReport/stats/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/purchase-invoice-item-reports/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const purchaseInvoiceItemReport = {
  getAll: apiPathFunc(pathBase),
  stats,
  exportPDF,
  exportExcel,
  exportSinglePDF,
};
